import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "flex flex-col justify-start w-full" }
const _hoisted_2 = { class: "form-label mt-3 w-full flex sm:flex-row justify-between items-center space-x-2" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 1,
  class: "sm:ml-auto px-2 pt-0.5 bg-slate-200 text-slate-600 dark:bg-darkmode-300 dark:text-slate-400 text-xs rounded-md"
}
const _hoisted_5 = { class: "input-group" }
const _hoisted_6 = {
  key: 0,
  class: "grid grid-cols-3 gap-2 items-start w-full h-9"
}
const _hoisted_7 = { class: "h-8 flex justify-between items-center space-x-1 bg-slate-100 dark:bg-darkmode-400 rounded-md px-2 py-1" }
const _hoisted_8 = {
  key: 0,
  class: "text-xs break-words"
}
const _hoisted_9 = {
  key: 1,
  class: "text-xs break-words"
}
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { class: "text-gray-500 font-medium text-sm" }
const _hoisted_12 = {
  key: 0,
  class: "input-group-text flex items-center justify-center !bg-primary"
}
const _hoisted_13 = {
  key: 0,
  class: "text-red-600 pt-1 text-left"
}

import {
  watch,
  reactive,
  watchEffect,
  computed,
  onMounted,
  toRefs,
  inject,
  ref,
} from "vue";
interface Props {
  modelText: any;
  label?: string;
  placeholder?: string;
  disabled?: boolean;
  tag?: string;
  rule: any;
  loading? : boolean,
  isObject : boolean,
  itemText : any,
  icon: {
    name: string;
    color: string;
    darkColor : string;
    front: boolean;
    back: boolean;
  };
}


export default /*#__PURE__*/_defineComponent({
  __name: 'MultipleSelect',
  props: {
    modelText: { default: [] },
    label: { default: "" },
    placeholder: {},
    disabled: { type: Boolean, default: false },
    tag: { default: "" },
    rule: {},
    loading: { type: Boolean, default: false },
    isObject: { type: Boolean, default: false },
    itemText: { default: 'text' },
    icon: {}
  },
  emits: ["update:modelText", "removeSelected"],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;
const props = __props;

const { modelText, label, placeholder, disabled, tag, rule } = toRefs(props);

const CLASS = {
  OUTLINE_NONE: 'outline outline-none',
  OUTLINE_SUCCESS: 'outline outline-none',
  OUTLINE_DANGER: 'outline outline-danger',
}

const _modelValue = computed({
  get() {
    return modelText.value;
  },
  set(val) {
    emit("update:modelText", val);
  },
});

const error = ref<boolean | string>("");

onMounted(() => {
  if (rule.value) {
    error.value = "";
  }
});

watch(
  () => _modelValue.value,
  (val, oldval) => {
    if (rule.value) {
      error.value = rule.value(val);
    }
  },
  { deep: true }
);

const _placeholder = computed(() => {
  return placeholder?.value === undefined ? label.value : placeholder.value;
});

const removeSelected = (index: number) => {
  emit("removeSelected", index);
};

return (_ctx: any,_cache: any) => {
  const _component_icon_button = _resolveComponent("icon-button")!
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_unref(label))
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_unref(label)), 1))
        : _createCommentVNode("", true),
      (_unref(tag))
        ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_unref(tag)), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", {
        class: _normalizeClass(["form-control form-control-sm border-success flex justify-start items-center space-x-2 overflow-auto", [_unref(disabled) ? 'cursor-not-allowed' : 'cursor-pointer',error.value === '' ? CLASS.OUTLINE_NONE : error.value !== true ? CLASS.OUTLINE_DANGER : CLASS.OUTLINE_SUCCESS]])
      }, [
        (_modelValue.value?.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_modelValue.value, (data, idx) => {
                return (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  (!_ctx.isObject)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(data), 1))
                    : (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(data[_ctx.itemText]), 1)),
                  _createElementVNode("div", null, [
                    _createVNode(_component_icon_button, {
                      onClick: ($event: any) => (removeSelected(idx)),
                      name: "Remove",
                      icon: "X",
                      color: "danger",
                      size: "4",
                      class: "z-60"
                    }, null, 8, ["onClick"])
                  ])
                ]))
              }), 256))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createElementVNode("span", _hoisted_11, _toDisplayString(_placeholder.value), 1)
            ]))
      ], 2),
      (_ctx.icon)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            (!_ctx.loading)
              ? (_openBlock(), _createBlock(_component_Icon, {
                  key: 0,
                  name: _ctx.icon?.name,
                  size: "4",
                  color: _ctx.icon?.color || 'white',
                  darkColor: _ctx.icon?.darkColor || 'white'
                }, null, 8, ["name", "color", "darkColor"]))
              : _renderSlot(_ctx.$slots, "loadingBar", { key: 1 })
          ]))
        : _createCommentVNode("", true)
    ]),
    (error.value !== true)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(error.value), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})